import { httpGet, httpPost, httpDelete } from "@/request/http";

let path = "/giftvouchers";

export default {
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  getByNumber(num) {
    return httpGet(`${path}/number/${num}`);
  },
  save(item) {
    return httpPost(path, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  getImage(id) {
    return httpGet(`${path}/${id}/image`, null, { responseType: "blob" });
  },
  saveImage(id, item) {
    return httpPost(`${path}/${id}/image`, item);
  },
  removeImage(id) {
    return httpDelete(`${path}/${id}/image`);
  },
};
